import React from 'react';
import { Helmet } from 'react-helmet-async';
import { useSeoSettings } from '../../hooks/useHomepageQueries';

const SEOHead = ({
  title,
  description,
  image,
  url,
  type = 'website',
  keywords = '',
  noIndex = false
}) => {
  const { data: seoSettings, isLoading } = useSeoSettings();

  // If loading settings, we don't block render, we just let Helmet fall back
  const defaultTitle = seoSettings?.defaultMetaTitle || 'CureHive Nepal | Medical & Dental Supplies';
  const defaultDescription = seoSettings?.defaultMetaDescription || 'Your trusted B2B partner for top-quality medical, dental, and surgical supplies in Nepal.';
  const defaultImage = seoSettings?.defaultSocialImage || 'https://curehivenepal.com/uploads/logo-orange.png';

  const finalTitle = title || defaultTitle;
  const finalDescription = description || defaultDescription;
  const finalImage = image || defaultImage;
  const finalUrl = url || (typeof window !== 'undefined' ? window.location.href : 'https://curehivenepal.com');

  // Trigger Google Analytics if configured
  React.useEffect(() => {
    if (!isLoading && seoSettings?.googleAnalyticsId && typeof window !== 'undefined' && window.gtag) {
      window.gtag('config', seoSettings.googleAnalyticsId, {
        page_title: finalTitle,
        page_location: finalUrl
      });
    }
  }, [isLoading, seoSettings, finalTitle, finalUrl]);

  return (
    <Helmet>
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content={noIndex ? 'noindex, nofollow' : 'index, follow'} />

      {/* Open Graph */}
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={finalImage} />
      <meta property="og:url" content={finalUrl} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content="CureHive Nepal" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={finalImage} />

      {/* Canonical */}
      <link rel="canonical" href={finalUrl} />
    </Helmet>
  );
};

export default SEOHead;